import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

type DiscountManagementQueryParams = {
  startDate?: string;
  endDate?: string;
  isAvailable?: boolean;
  isActive?: boolean;
  search?: string;
};

export const useGetDiscountsQuery = (params: DiscountManagementQueryParams) => {
  const token = getToken();

  return useQuery({
    queryKey: ["useGetDiscountQuery", params],
    queryFn: () =>
      axiosInstance
        .get("discounts", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(
    //     error?.response?.data?.message ||
    //       "An error occurred while fetching credits."
    //   );
    // },
    enabled: !!token,
  });
};
